module.exports = __webpack_public_path__ + "static/media/ownGoals.24bda322.svg";